module.exports = __webpack_public_path__ + "img/3_192.610318f7.png";